var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-attachment-viewer',{staticClass:"ml-3 mb-3",attrs:{"attachment":_vm.attachment,"discard-visible":_vm.isInputsEnabled},on:{"discard":_vm.fileRemove}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }